<template>
  <nav-bar title="调整非法经营企业" />
  <Content :bottom="80" >
    <van-form class="form" ref="form" @submit="onSubmit">
      <van-field
        v-model="name"
        name="name"
        label="公司名称"
        placeholder="公司名称"
        :rules="[{ required: true, message: '请填写公司名称' }]"
      />
      <van-field
        v-model="version"
        name="version"
        label="排序"
        placeholder="排序"
        :rules="[{ required: true, message: '请填写排序' }]"
      />
      <van-field
        v-model="commodity"
        name="commodity"
        label="商品"
        placeholder="选择商品"
        is-link
        readonly
        :rules="[{ required: true, message: '请选择商品' }]"
        @click="handleCommodityClick"
      />
      <Picker
        label="街道"
        pickerType="cascader"
        @confirm-values="value => (streetCode = value)"
      />
      <van-field
        v-model="address"
        name="address"
        label="地址"
        placeholder="地址"
        :rules="[{ required: true, message: '请填写地址' }]"
      />
      <SelectPoint @get-value="selectPoint" />
    </van-form>
  </Content>
  <div class="fixed-btn">
    <van-button block type="primary" native-type="button" :loading="loading" :disabled="loading" loading-text="请稍后" @click="handleSubmitClick">
      确认提交
    </van-button>
  </div>
  <!-- 选择商品 -->
  <commodity-popup ref="commodityPopup" :commodityList="commodityList" @change-checked="onChangeCheked" />
</template>

<script>
import { ref, reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'
import { getGoodsList } from '@/api/createCompany'
import { addCompanyByIllegal } from '@/api/companyList'
import { useGetData } from '@/hooks/useGetData'
import { useSubmit } from '@/hooks/useSubmit'
import SelectPoint from './SelectPoint.vue'

export default {
  name: 'AdjustAEnterpriseDetail', // 调整非法经营企业
  components: { SelectPoint },
  props: ['cid', 'cname'],
  setup (props) {
    // 获取商品列表
    const commodityList = ref([])
    const getCommodityList = useGetData(getGoodsList, (value) => {
      commodityList.value = value
    })
    getCommodityList()

    // 选择商品
    const formData = reactive({
      cid: props.cid,
      name: props.cname,
      version: '',
      commodity: '',
      goodsList: [],
      longitude: 0.0,
      latitude: 0.0,
      streetCode: '',
      address: ''
    })
    const commodityPopup = ref(null)
    const handleCommodityClick = () => { // 弹出商品列表
      commodityPopup.value.show = true
    }
    const onChangeCheked = ({ lable, value }) => { // 确认选择商品
      formData.commodity = lable.join(',')
      formData.commodityValue = value
      formData.goodsList = value.map(item => ({ goodsId: item }))
    }
    // 选择位置
    const point = ref('') // 位置
    const selectPoint = value => {
      point.value = value
      formData.longitude = value[1]
      formData.latitude = value[0]
    }
    // 提交表单
    const router = useRouter()
    const form = ref(null)
    const handleSubmitClick = () => {
      form.value.submit()
    }
    const { loading, onSubmit } = useSubmit(addCompanyByIllegal, formData, () => {
      router.replace('/companyList')
    })

    return {
      onSubmit,
      ...toRefs(formData),
      handleSubmitClick,
      form,
      commodityPopup,
      handleCommodityClick,
      onChangeCheked,
      commodityList,
      selectPoint,
      loading
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-top: 16px;
}
.btn {
  margin: 16px;
}
.fixed-btn {
  position: absolute;
  height: 80px;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
}
</style>
